import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { preventDefault } from '@/packages/utils/event';

import { Title } from './Title';

export const TitleContainer: FC = () => {
  const { title, url } = useCardOfferDataContext();

  /**
   * @description в заголовке используем тег <a> так как это требования СЕО, но у нас трек и переход на карточку при
   *   нажатии почти на все места и так, поэтому убираем дефолтное поведение и не трекаем клик разумеется
   */
  return <Title href={url} title={title} onClick={preventDefault} />;
};
